<template>
  <p dir="rtl" style="margin: 0;" ><b>זמן שיחה:</b> {{timer}}</p>
</template>
<script>
export default {
  name: 'timer',
  data () {
    return {
      timer: '00:00',
      start_time_stamp: this.$moment().startOf('day'),
      interval: {}
    }
  },
  created () {
    this.startTimer()
  },
  beforeDestroy () {
    this.clearTimer()
  },
  methods: {
    startTimer () {
      this.interval = setInterval(this.handleTimer, 1000)
    },
    handleTimer () {
      this.start_time_stamp.add(1, 'second')
      this.timer = this.start_time_stamp.format('mm:ss')
      this.$emit('input', this.timer)
    },
    clearTimer () {
      clearInterval(this.interval)
    }
  }
}
</script>
